import React from 'react';
import pluralize from 'pluralize';

interface Props {
    count: number;
    objectTitle: string;
}

export const ActionBarCount = (props: Props) => {
    const {count, objectTitle} = props;

    return (
        <div className="actionBarCount">
            <div className="count">{count}</div>
            <h4>{pluralize(objectTitle, count)} selected</h4>
        </div>
    );
};

export default ActionBarCount;
